import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import { getSecondaryColor } from '../../services/get-colors';
import Textarea from 'react-textarea-autosize';
import styles from './input-text.scss';

class InputText extends Component {
  state = {
    hasFocus: false,
  };

  constructor(props) {
    super(props);

    this.handleBlur = this.handleBlur.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
  }

  handleBlur() {
    this.setState({ hasFocus: false });
  }

  handleFocus() {
    this.setState({ hasFocus: true });
  }

  renderCounter() {
    const { value, maxLength } = this.props;
    const left = maxLength - value.length;
    if (maxLength) {
      return (
        <span
          className={classNames(styles.counter, { [styles.hasFocus]: this.state.hasFocus })}
          style={left === 0 ? { color: getSecondaryColor() } : null}
        >
          {left}
        </span>
      );
    }
  }

  render() {
    const { className, containerClassName, ...props } = this.props;
    return (
      <div className={classNames(styles.inputWrapper, containerClassName)}>
        <Textarea
          className={classNames(styles.input, className)}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          {...props}
        />
        {this.renderCounter()}
      </div>
    );
  }
}

InputText.propTypes = {
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  maxLength: PropTypes.number,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
};

export default InputText;



// WEBPACK FOOTER //
// ./app/components/input-text/input-text.js